/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_SolutionsInputs */

const en_mk_foot_solutions = /** @type {(inputs: Mk_Foot_SolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who it is for`)
};

const id_mk_foot_solutions = /** @type {(inputs: Mk_Foot_SolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk siapa`)
};

/**
* | output |
* | --- |
* | "Who it is for" |
*
* @param {Mk_Foot_SolutionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_solutions = /** @type {((inputs?: Mk_Foot_SolutionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_SolutionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_solutions(inputs)
	return en_mk_foot_solutions(inputs)
});